


import React, { useState, useEffect } from 'react';
import styles from '../../../src/assets/scss/CreateOrders.module.scss';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    useAddItemToOrderMutation,
    useGetItemBagsQuery,
    useGetItemsByStoreQuery,
    useGetUserByIdQuery,
    useUpdateOrderItemMutation,
} from '../../slices/admin/admin';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { getUserInfo } from '../../utils/user.util';


const AddItem = ({ popupMode = false, closePopup, passedState, onItemUpdate }) => {
    const navigate = useNavigate();
    const location = useLocation();

  const localUser = getUserInfo();
  const userId = localUser?._id;

  const { data: userData } = useGetUserByIdQuery(userId, { skip: !userId });
  //console.log(userData, "localUserwdwdfwdf");

    const [itemType, setItemType] = useState('raw');
    const [selectedItem, setSelectedItem] = useState('');
    const [quantity, setQuantity] = useState('');
    const [bagType, setBagType] = useState('');

    const state = popupMode ? passedState : location.state || {};
    const storeId = state?.storeId || userData?.result?.[0]?.store?._id;
    const editIndex = state?.editIndex;
    const existingItem = state?.itemData;
    const itemId = state?.itemId;
    const updateMode = state?.updateMode;
    const orderId = state?.orderId;

    const { data, isLoading, isError, error } = useGetItemsByStoreQuery(storeId, { skip: !storeId });
    const { data: bagData, isLoading: isBagLoading, isError: isBagError } = useGetItemBagsQuery();
    const [addItemToOrder] = useAddItemToOrderMutation();
    const [updateOrderItem, { isLoading: isUpdatingItem }] = useUpdateOrderItemMutation();

    const items = data?.items || [];

    useEffect(() => {
        if (items.length > 0 && existingItem) {
            const nameToMatch = existingItem?.itemName || existingItem?.productName;
            const match = items.find(item => item.itemCategory === nameToMatch);
            if (match) setSelectedItem(match._id);
        }
    }, [items, existingItem]);

    useEffect(() => {
        if (existingItem) {
            setBagType(existingItem.productBag || existingItem.bag);
            setItemType(existingItem.productType || 'raw');
            const quantityVal = existingItem.productBag === 'kilogram' || existingItem.bag === 'kilogram'
                ? existingItem.productQuantity
                : existingItem.productCount;
            setQuantity(quantityVal !== undefined ? String(quantityVal) : '');
        }
    }, [existingItem]);

    useEffect(() => {
        if (!storeId) {
            toast.error('Store ID is required');
            handleClose();
        }
    }, [storeId]);

    useEffect(() => {
        if (isError) {
            toast.error('Failed to fetch items');
            console.error('API Error:', error);
        }
    }, [isError, error]);

    const handleSave = async () => {
        if (!selectedItem || !quantity || !bagType) {
            toast.error('Please fill all fields');
            return;
        }

        const selectedItemData = items.find(item => item._id === selectedItem);
        if (!selectedItemData) {
            toast.error('Selected item not found');
            return;
        }

        const quantityNumber = Number(quantity);
        if (isNaN(quantityNumber) || quantityNumber <= 0) {
            toast.error('Please enter a valid quantity');
            return;
        }

        const payload = {
            productName: selectedItemData.itemCategory,
            productBag: bagType,
            productType: itemType,
            ...(bagType === 'kilogram'
                ? { productQuantity: quantityNumber }
                : { productCount: quantityNumber }
            )
        };

        try {
            if (updateMode) {
                if (itemId) {
                    await updateOrderItem({ id: itemId, body: payload }).unwrap();
                    toast.success('Item updated successfully');
                } else if (orderId) {
                    await addItemToOrder({ orderId, body: payload }).unwrap();
                    toast.success('Item added successfully');
                } else {
                    toast.error('Order ID is missing');
                    return;
                }

                if (typeof onItemUpdate === 'function') onItemUpdate();
                handleClose();
            } else {
                const existing = JSON.parse(localStorage.getItem('orderItems') || '[]');
                const itemData = {
                    itemId: selectedItem,
                    itemName: selectedItemData.itemCategory,
                    productBag: bagType,
                    productType: itemType,
                    ...(bagType === 'kilogram'
                        ? { productQuantity: quantityNumber }
                        : { productCount: quantityNumber }
                    )
                };

                if (typeof editIndex === 'number') {
                    existing[editIndex] = itemData;
                } else {
                    existing.push(itemData);
                }

                localStorage.setItem('orderItems', JSON.stringify(existing));
                setTimeout(() => {
                    toast.success(`Item ${typeof editIndex === 'number' ? 'updated' : 'added'} successfully`);
                    if (typeof onItemUpdate === 'function') onItemUpdate();
                    handleClose();
                }, 0);
            }
        } catch (err) {
            toast.error('Failed to save item');
            console.error(err);
        }
    };

    const handleClose = () => {
        if (popupMode && typeof closePopup === 'function') {
            closePopup();
        } else {
            navigate('/dashboard/CreateOrders', { state });
        }
    };

    const itemOptions = items.map(item => ({
        value: item._id,
        label: item.itemCategory
    }));

    if (isLoading) return <div>Loading items...</div>;

    return (
        <div className={styles.createOrdersContainers}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>
                    {editIndex !== undefined ? 'Edit Item' : 'Add Item'}
                </h2>
                <span className={styles.closeIcon} onClick={handleClose}>✕</span>
            </div>
            <div className={styles.container}>
                <div className={styles.formSection}>
                    <div className={styles.formLeft}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Item Category</label>
                            <div className={styles.selectWrapper}>
                                <Select
                                    className={styles.customSelect}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            border: '1px solid #6D6D6D',
                                            borderRadius: '6px',
                                            fontSize: '16px',
                                            minHeight: '50px',
                                            boxShadow: 'none',
                                            color: 'black',
                                            fontWeight: '600',
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            color: '#6D6D6D',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                        }),
                                    }}
                                    options={itemOptions}
                                    value={itemOptions.find(option => option.value === selectedItem)}
                                    onChange={(selected) => setSelectedItem(selected?.value)}
                                    placeholder="Select Item"
                                    isSearchable
                                />
                            </div>
                        </div>



                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Item Scales</label>
                            <select
                                className={styles.inputs}
                                value={bagType}
                                onChange={(e) => setBagType(e.target.value)}
                            >
                                <option value="">Select Bag</option>
                                {isBagLoading ? (
                                    <option>Loading...</option>
                                ) : isBagError ? (
                                    <option>Error loading bags</option>
                                ) : (
                                    bagData?.itemBags?.map((bag) => (
                                        <option key={bag._id} value={bag.itemBag}>
                                            {bag.itemBag}
                                        </option>
                                    ))
                                )}
                            </select>
                        </div>
                    </div>

                    <div className={styles.formRights}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Item Type</label>
                            {/* <select
                                className={styles.inputs}
                                value={itemType}
                                onChange={(e) => setItemType(e.target.value)}
                            >
                                <option value="">Select Type</option>
                                <option value="raw">Raw</option>
                                <option value="cut">Cut</option>
                            </select> */}
                            <select
                                className={styles.inputs}
                                value={itemType}
                                onChange={(e) => {
                                    const selectedType = e.target.value;
                                    setItemType(selectedType);

                                    // Force bagType to 'kilogram' if type is 'cut'
                                    if (selectedType === 'cut') {
                                        setBagType('kilogram');
                                    }
                                }}
                            >
                                <option value="">Select Type</option>
                                <option value="raw">Whole veggie</option>
                                <option value="cut">Cut veggie</option>
                            </select>

                        </div>

                        {bagType === 'kilogram' ? (
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Item Quantity (kg)</label>
                                <input
                                    placeholder="Enter Quantity in Kilograms"
                                    name="ItemQuantityKg"
                                    className={styles.input}
                                    type="number"
                                    min="0.1"
                                    step="0.1"
                                    value={quantity}
                                    onChange={(e) => setQuantity(e.target.value)}
                                />
                            </div>
                        ) : (
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Item Count</label>
                                <input
                                    placeholder="Enter Item Count"
                                    name="ItemQuantity"
                                    className={styles.input}
                                    type="number"
                                    min="1"
                                    value={quantity}
                                    onChange={(e) => setQuantity(e.target.value)}
                                />
                            </div>
                        )}

                    </div>
                </div>

                <div className={styles.footerButtons}>
                    <button className={styles.cancel} onClick={handleClose}>Cancel</button>
                    <button
                        onClick={handleSave}
                        className={styles.saves}
                        disabled={isLoading || isError || isUpdatingItem}
                    >
                        {editIndex !== undefined ? 'Update' : 'Add'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddItem;
